import React, { useState } from 'react';
import Sidebar from './sidebar';
import Header from './header';
import ReactNotification from 'react-notifications-component'

const Layout = (props: any) => {
    const [showSidebar, setshowSidebar] = useState(false);
    return (
        <div id="main-wrapper">
            <Header showSidebar={(flag: boolean) => setshowSidebar(flag)} sidebar={showSidebar}></Header>
            <Sidebar show={showSidebar} linkClicked={() =>  setshowSidebar(false)}></Sidebar>
            <div className="page-wrapper">
                    <ReactNotification />
                    {props.children}
            </div>
        </div>
    );
}

export default Layout;